<template>
  <rabbey-top-menu />
</template>

<script>
export default {
  name: "CustomerService"
};
</script>
